import { type ViewLayoutRegistry } from '@databases/view-layout-modules';

/**
 * Resolves a registered extension renderer only while its data module is
 * writable. Read-only rollback mode preserves persisted data while the legacy
 * layout remains visible.
 */
export function resolveExtensionLayoutRenderer<Renderer>(
  registry: Pick<ViewLayoutRegistry, 'isWritable'>,
  persistedLayoutType: string | undefined,
  renderers: ReadonlyMap<string, Renderer>
): Renderer | undefined {
  if (!persistedLayoutType) {
    return undefined;
  }

  const renderer = renderers.get(persistedLayoutType);

  return renderer && registry.isWritable(persistedLayoutType) ? renderer : undefined;
}
